import React from 'react';
import './AboutPage.css';
import cert1 from './assets/Armatura.jpg';
import cert2 from './assets/Ugolok.jpg';

const AboutPage = () => {
  const [modalSrc, setModalSrc] = React.useState(null);

  // Закрытие лайтбокса по ESC
  React.useEffect(() => {
    if (!modalSrc) return;
    const onKey = (e) => e.key === 'Escape' && setModalSrc(null);
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [modalSrc]);

  return (
    <div className="about-wrapper">
      <div className="about-container">
        <h2 className="about-heading">О компании</h2>

        <p>
          ООО «ГСП Переработка» входит в  состав многопрофильного холдинга «Газстройпром». Предприятие основано в 2016 году и является
          единственным предприятием в группе компаний ПАО «Газпром», выполняющим комплекс работ по ликвидации объектов неиспользуемых
          газотранспортных мощностей, переработки и утилизации лома и отходов III–V класса опасности с площадок хранения.
        </p>
        <p>
          Компания осуществляет свою деятельность в полном соответствии с природоохранным законодательством Российской Федерации.
          Работники регулярно обучаются на курсах повышения квалификации.
        </p>
        <p>
          Поручениями Председателя Правления ПАО «Газпром» А.Б. Миллера, АО «Газстройпром» назначено уполномоченной организацией,
          ответственной за ликвидацию объектов газотранспортной сети, утилизацию и переработку лома чёрных и цветных металлов,
          включая труб, бывших в эксплуатации, отнесённых к отходам III–V класса опасности, а также за восстановление труб
          в заводских и базовых условиях.
        </p>
        <p>
          Для оптимизации данных процессов было создано 100% дочернее общество — ООО «ГСП Переработка», основной задачей которого
          является безусловное исполнение поручений.
        </p>
        <p>
          Мы видим и реализуем каждую возможность сделать шаг вперёд. Используя комплексный подход и анализ процессов,
          компания внедряет систему бережливого производства.
        </p>

        <h3 className="about-subheading">ОСНОВНЫЕ НАПРАВЛЕНИЯ ДЕЯТЕЛЬНОСТИ</h3>
        <ul>
          <li>Переработка и утилизация лома чёрных и цветных металлов, включая отходы III–V класса опасности</li>
          <li>Производство металлоизделий различного назначения</li>
          <li>
            Восстановление труб диаметром 530–1420 мм, демонтированных на объектах капитального ремонта и модернизации магистральных
            газопроводов, с целью их повторного применения в соответствии с СТО ПАО «Газпром» 2-2.3-1178-2019
          </li>
          <li>Ликвидация объектов газотранспортной сети ПАО «Газпром»</li>
        </ul>

        {/* Видео и материалы — 2 кнопки в ряд, на мобилке по одной */}
        <section className="about-links" aria-label="Видео и материалы">
          <h3 className="about-subheading">ВИДЕО И МАТЕРИАЛЫ</h3>
          <div className="links-grid two-columns">
            {/* 1-й ряд */}
            <a
              className="btn-primary btn-stacked"
              href="https://disk.yandex.ru/i/eWuIJXNf4GJvGg"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className="btn-title">Имиджевое видео</span>
              <span className="btn-subtitle">ООО «ГСП Переработка»</span>
            </a>

            <a
              className="btn-primary"
              href="https://metallpererabotka.ru/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Готовая продукция
            </a>

            {/* 2-й ряд */}
            <a
              className="btn-outline"
              href="https://disk.yandex.ru/d/i6DGMEw15iKmjA"
              target="_blank"
              rel="noopener noreferrer"
              title="Внутри: краткий и полный ролики с начала ГСПП"
            >
              Производственные процессы — г. Грозный
            </a>

            <a
              className="btn-outline"
              href="https://disk.yandex.ru/d/W0gOWCcf8YfEgA"
              target="_blank"
              rel="noopener noreferrer"
            >
              Производственные процессы — г. Астрахань
            </a>
          </div>
        </section>

        {/* Сертификаты */}
        <section className="certificates" aria-label="Сертификаты качества">
          <h3 className="about-subheading">СЕРТИФИКАТЫ КАЧЕСТВА</h3>
          <div className="certificates-images">
            <figure
              className="cert-card"
              onClick={() => setModalSrc(cert1)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && setModalSrc(cert1)}
            >
              <img
                src={cert1}
                alt="Сертификат соответствия: Арматура — РОСС RU.04ПТК0.С0037"
                loading="lazy"
              />
              <figcaption>Арматура — РОСС RU.04ПТК0.С0037</figcaption>
            </figure>

            <figure
              className="cert-card"
              onClick={() => setModalSrc(cert2)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && setModalSrc(cert2)}
            >
              <img
                src={cert2}
                alt="Сертификат соответствия: Уголок — РОСС RU.04ПТК0.С0037"
                loading="lazy"
              />
              <figcaption>Уголок — РОСС RU.04ПТК0.С0037</figcaption>
            </figure>
          </div>

          <div className="cert-actions">
            <a href={cert1} download className="btn-outline">Скачать сертификат (Арматура)</a>
            <a href={cert2} download className="btn-outline">Скачать сертификат (Уголок)</a>
          </div>
        </section>
      </div>

      {/* Лайтбокс */}
      {modalSrc && (
        <div className="lightbox" role="dialog" aria-modal="true" onClick={() => setModalSrc(null)}>
          <img
            src={modalSrc}
            alt="Просмотр сертификата в полном размере"
            onClick={(e) => e.stopPropagation()}
          />
          <button className="lightbox-close" aria-label="Закрыть" onClick={() => setModalSrc(null)}>✕</button>
        </div>
      )}
    </div>
  );
};

export default AboutPage;
